import { render, staticRenderFns } from "./ClassifiedProducts.vue?vue&type=template&id=fbd5271c&scoped=true"
import script from "./ClassifiedProducts.vue?vue&type=script&lang=js"
export * from "./ClassifiedProducts.vue?vue&type=script&lang=js"
import style0 from "./ClassifiedProducts.vue?vue&type=style&index=0&id=fbd5271c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd5271c",
  null
  
)

export default component.exports